const InputCheckbox = (props) => (
  <>
    {console.log(props.item, 'leart3')}
    <input
      type='checkbox'
      name={'name' + props.item.id}
      value={props.item.id}
      id={props.item.id}
      checked={props.item.selected}
      disabled={props.disabled}
      onChange={() => props.dispatch(props.onChangeCheckbox(props.index))}
      className='answer-input'
    />
  </>
)

export default InputCheckbox
